import axios from "axios";
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const AbortControllerContext = createContext();

export const reason = Symbol("Abort all api on unmount!");

export const isAbortOnLeaveError = (error) => {
  return axios.isCancel(error) && error?.config?.signal?.reason === reason;
};

export const useAbortController = () => useContext(AbortControllerContext);

export const AbortControllerProvider = ({ children }) => {
  const [abortController] = useState(() => new AbortController());

  const abort = useCallback(() => {
    abortController.abort();
  }, [abortController]);

  useEffect(() => {
    return () => {
      abortController.abort(reason);
    };
  }, [abortController]);

  return (
    <AbortControllerContext.Provider value={{ signal: abortController.signal, abort }}>
      {children}
    </AbortControllerContext.Provider>
  );
};
